module.exports = __webpack_public_path__ + "6d7700c9bc96994144f8dab41cb58e87.MP3";